/**
 * TUT-396 — o texto da falha de uma ação: a mensagem que a API mandou, ou a
 * frase da tela quando não há nenhuma. Existia copiado em cada tela
 * (`mensagemDoErro`, `mensagemDe`); este é o ponto único para as novas.
 */
export function mensagemDaFalha(erro: unknown, padrao: string): string {
  return erro instanceof Error && erro.message ? erro.message : padrao;
}
